import { isFunction } from 'lodash';
import { updateClientId } from '../api/updateClientId';
import { setGetUserById } from './setGetUserById';

export const setUpdateClientId = (params, callback) => {
    return async (dispatch, getState) => {
        try {
            await updateClientId(params);
            if (isFunction(callback)) {
                callback();
            }
            dispatch(setGetUserById(params?.user_id));
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}